var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testPage"},[_c('realTimeBusBox'),_c('pointMallBox'),_c('equityCenterBox'),_c('vipBox'),_c('metroBox'),_c('MaaSBox'),_c('parkCarBox'),_c('AirplaneBox'),_c('trainBox'),_c('coachBox'),_c('qrCodeBox'),_c('takeTaxiBox')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }